<template>
    <a
        :class="{
            'l-ss-c-completions-item-is-active': isActive,
            'l-ss-c-completions-item-is-current': (data.active === 1),
        }"
        :href="data.url"
        :target="$configuration.linkTargetBlank ? '_blank': '_self'"
        class="l-ss-c-completions-item l-ss-c-completions-item-category">
        <span class="l-ss-c-completions-item-category-img-wrapper">
            <img
                v-if="hasImage"
                class="l-ss-c-completions-item-category-img"
                :src="data.image_url"
                @error="onErrorImg">
            <i
                v-else
                v-html="iconGallery"></i>
        </span>
        <div class="l-ss-c-completions-item-category-info">
            <span
                class="l-ss-c-completions-item-category-title"
                v-html="textLabel"></span>
            <span
                v-if="hierarchy"
                class="l-ss-c-completions-item-category-path"
                v-html="hierarchy">
            </span>
        </div>
        <span class="l-ss-c-completions-item-category-count">
            {{ data.count }}
        </span>
    </a>
</template>

<script>
    import { ref, computed } from '@/lib/vue-composition-api.js';

    import arrowDownIcon from '@/core/assets/images/icons/arrow-down.svg';
    import iconGallery from '@/core/assets/images/icons/gallery.svg';

    export default {
        props: {
            isActive: {
                type: Boolean,
                required: false,
                default: false,
            },
            data: {
                type: Object,
                required: true,
            },
            textLabel: {
                type: String,
            },
        },
        setup(props) {
            const labelToken = computed(() => {
                return props.data.label;
            });

            const hierarchy = computed(() => {
                const hierarchyTokens = props.data.hierarchy?.split('>') || [];

                if (!hierarchyTokens.length) {
                    return '';
                }

                return hierarchyTokens.join(arrowDownIcon);
            });

            const hasImage = ref(props.data.image_url);

            const onErrorImg = (event) => {
                hasImage.value = false;
            };

            return {
                labelToken,
                hierarchy,
                hasImage,
                onErrorImg,
                iconGallery,
            };
        },
    /*
     * Computed: {
     *     labelToken() {
     *         return this.data.label;
     *     },
     *     hierarchy() {
     *         const hierarchyTokens = this.data.hierarchy?.split('>') || [];
     *
     *         if (!hierarchyTokens.length) {
     *             return '';
     *         }
     *
     *         return hierarchyTokens.join(arrowDownIcon);
     *     },
     * },
     */
    };

</script>
